export { default as PageHeader } from './PageHeader';
export { default as SubHeader } from './SubHeader';
export { default as ModalHeader } from './ModalHeader';
export { default as Body } from './Body';
export { default as ButtonText } from './ButtonText';
export { default as Caption } from './Caption';
export { default as Tiny } from './Tiny';
